<template>

<div>
    
    <profile-header></profile-header>

    <div class="container">
        <my-projects v-if='page == "my-projects"'></my-projects>
        <part-projects v-if='page == "part-projects"'></part-projects>
        <profile v-if='page == "profile"'></profile>
        <company-info v-if='page == "company-info"'></company-info>
        <notifications v-if='page == "notifications"'></notifications>
        <!-- <pwd-change v-if='page == "password-change"'></pwd-change> -->
    </div>

</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {

            if( typeof this.$route.params.page == 'undefined' ) {
                this.page = 'profile';
            } else {
                this.page = this.$route.params.page;
            }
        },

        data() {
            return {
                page : false,
                isReady : false,
            }
        },

        methods : {
            changePage(p) {
                this.page = p;
            }
        },

        components : {
            'profile-header'    : require("./ProfileHeader.vue").default,
            'company-info'      : require("./CompanyInfo.vue").default,
            'profile'           : require("./Profile.vue").default,
            'notifications'     : require("./Notifications.vue").default,
            'my-projects'       : require("../Projects/MyProjects.vue").default,
            'part-projects'     : require("../Projects/PartProjects.vue").default,
            // 'pwd-change'        : require("./PasswordChange.vue").default,
            // 'roles'             : require("./Roles.vue").default,
        }

    }
</script>
